<template>
  <div>
    <div class="card mb-5 mb-xl-10">
      <!-- <BlockUI :loading="true" /> -->
      <div class="card-body pt-9 pb-0">
        <!--begin::Details-->
        <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
          <!--begin::Info-->
          <div class="flex-grow-1">
            <!--begin::Title-->
            <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
              <!--begin::User-->
              <div class="d-flex flex-column">
                <!--begin::Name-->
                <div class="d-flex align-items-center mb-2">
                  <a class="text-gray-800 text-hover-primary fs-2 fw-bolder me-1">{{ company.Name }}</a>
                </div>
                <!--end::Name-->

                <!--begin::Info-->
                <div class="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                  <a class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                    {{ company.CountryName }}
                  </a>
                  <a
                    v-show="company.CityName !== null || company.DistrictName !== null"
                    class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
                  >
                    <span class="svg-icon svg-icon-4 me-1">
                      <inline-svg src="media/icons/duotune/general/gen018.svg" />
                    </span>
                    {{ company.CityName + ", " + company.DistrictName }}
                  </a>
                  <a
                    :href="`mailto:${company.Email}`"
                    class="d-flex align-items-center text-gray-400 text-hover-primary mb-2"
                  >
                    <span class="svg-icon svg-icon-4 me-1">
                      <inline-svg src="media/icons/duotune/communication/com011.svg" />
                    </span>
                    {{ company.Email }}
                  </a>
                </div>
                <!--end::Info-->
              </div>
              <!--end::User-->

              <!--begin::Menu-->
              <!-- <div class="d-flex my-4">
                <div class="dropdown">
                  <button
                    class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                    type="button"
                    id="dropdownMenu2"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="bi bi-three-dots fs-3"></i>
                  </button>

                  <ul
                    class="dropdown-menu menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold py-4 px-4 w-250px fs-6"
                    aria-labelledby="dropdownMenu2"
                  >
                    <li class="">
                      <a
                        class="dropdown-item rounded fw-bold fs-7 py-2 px-4 disabled"
                        type="button"
                      >
                        <span class="text-dark">ADMIN</span>
                      </a>
                    </li>
                    <div class="separator mb-2"></div>
                    <li class="">
                      <a
                        class="dropdown-item rounded fw-bold fs-6 py-2 px-4 mb-1"
                        type="button"
                      >
                        <span>Customers</span>
                      </a>
                    </li>
                    <li class="">
                      <a
                        class="dropdown-item rounded fw-bold fs-6 py-2 px-4"
                        type="button"
                      >
                        <span class="text-danger">Delete customer</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div> -->
              <!--end::Menu-->
            </div>
            <!--end::Title-->
          </div>
          <!--end::Info-->
        </div>
        <!--end::Details-->

        <!--begin::Navs-->
        <div class="d-flex overflow-auto h-55px">
          <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-6 flex-nowrap">
            <!--begin::Nav item-->
            <li
              v-for="(item, index) in tabs"
              :key="index"
              class="nav-item"
            >
              <a
                :class="`nav-link me-6 ${tab === item.name ? 'active langue-tabs-bold' : ''} `"
                style="cursor: pointer"
                @click="changeTab(item)"
              >
                {{ translate(item.name) }}
              </a>
            </li>
            <!--end::Nav item-->
          </ul>
        </div>
        <!--begin::Navs-->
      </div>
    </div>
    <transition
      name="component-fade"
      mode="out-in"
    >
      <keep-alive>
        <component :is="showComponent"> </component>
      </keep-alive>
    </transition>
  </div>
</template>

<script setup>
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { reactive, ref, provide, shallowRef, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

const router = useRouter();

//Store Tanımlaması
const store = useStore();
const Id = store.state.AuthModule.User.CompanyId;
const tabs = ref([{ name: "Detail" }]);
const tab = ref("Detail");
const showComponent = shallowRef();
const changeTab = (item) => {
  tab.value = item.name;

  if (item.name !== "") {
    import("@/components/Admin/Company/Company-" + item.name + ".vue").then((value) => {
      showComponent.value = value.default;
    });
  }
};

// Multi Language
const { t, te, locale } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const companyId = ref(Id);

const company = reactive({
  Address: null,
  CityId: 0,
  CityName: null,
  CountryId: 0,
  CountryName: null,
  DefaultCountryId: 0,
  DefaultLanguageId: 0,
  Description: null,
  DistrictId: 0,
  DistrictName: null,
  Email: null,
  Firstname: null,
  Id: 0,
  Lastname: null,
  Name: null,
  PhoneNumber: null,
});

function getCompany(Id) {
  if (Id) {
    store.dispatch("CompanyModule/GET_COMPANY", Id).then((response) => {
      if (response === null) {
        router.push("/");
      } else {
        Object.keys(company).forEach((item) => {
          company[item] = response[item];
        });
      }
    });
  }
}

const closeModalEmit = (isSave) => {
  companyId.value = null;
  if (isSave === true) {
    getCompany(Id);
  }
};

const updateCompany = () => {
  companyId.value = Id;
};

getCompany(Id);

changeTab({ name: "Detail" });
provide("company", company);
provide("company_id", companyId.value);
provide("closeModalEmit", closeModalEmit);
provide("updateCompany", updateCompany);

watch(locale, () => {
  setCurrentPageBreadcrumbs(translate("Menu_CompanyPage"), []);
});

onMounted(() => {
  setCurrentPageBreadcrumbs(translate("Menu_CompanyPage"), []);
});
</script>

<style scoped>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter-from,
.component-fade-leave-to {
  opacity: 0;
}
</style>
